<template>
<div class="chapter">
<div class="inner_page">
<section class="pg-boilerplate pgheader" id="pg-header" lang="en"><h2 id="pg-header-heading" title=""><span id="pg-title-no-subtitle" lang="en">The moving finger</span></h2>
<div class="container" id="pg-machine-header"><p><strong>Title</strong>: The moving finger</p>
<div id="pg-header-authlist">
<p><strong>Author</strong>: Natalie Sumner Lincoln</p>
<p><strong>Illustrator</strong>: Charles L. Wrenn</p>
</div>
<p><strong>Release date</strong>: August 8, 2024 [eBook #74210]</p>
<p><strong>Language</strong>: English</p>
<p><strong>Original publication</strong>: New York and London: D. Appleton and Company</p>
<p><strong>Credits</strong>: D A Alexander, David E. Brown, and the Online Distributed Proofreading Team at https://www.pgdp.net (This file was produced from images generously made available by The Internet Archive)</p>
</div>
</section>
<div style="text-align:center"></div>
<div class="figcenter hide"><img alt="cover" id="img_images_coversmall.jpg" src="3624747857925452935_coversmall.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3186253215635795556_74210-h-0.htm.vue?72e287e6